export default "__VITE_ASSET__6prFaoiK__"